import React, { useEffect, useRef } from "react";

const iframeStyles = {
  width: "100%",
  height: "100vh",
  border: "none",
};
const IframeSendData = ({ SSOData, iframeUrl }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    if (SSOData) {
      window.addEventListener("message", (event) => {
        if (event.data?.message === "REQUEST_SSO") {
          event.source.postMessage(
            { message: "SSO_DATA", payload: SSOData },
            event.origin
          );
        }
      });
    }
  }, [iframeRef, SSOData]);
  return <iframe ref={iframeRef} style={iframeStyles} src={iframeUrl}></iframe>;
};

export default IframeSendData;
